// extracted by mini-css-extract-plugin
export default {"comments":"Comments_comments__GOPyH","not-found":"Comments_not-found__PQzFk","comment":"Comments_comment__ouVm3","comment-header":"Comments_comment-header__k6un7"};